import React from 'react'
import { IPayoutFields } from 'src/types/generated/contentful'
import { TextBlock, Type } from '@/components/common'
import useCampaign from '@/services/hooks/useCampaign'
import { formatMoney } from '@/utils'
import DetailsRow from './DetailsRow'
import { disclaimerOverride } from './textOverrides'

interface Props {
  payout: IPayoutFields
}

const DetailsCard: React.FC<Props> = ({ payout }) => {
  const { campaign } = useCampaign(payout.slug)

  return (
    <div className="grid grid-cols-1 gap-6 rounded-2xl border border-core-gray-300 bg-core-white p-8">
      <div>
        <Type as="h3" variant="title-lg" className="mb-1 font-bold">
          Payout Details*
        </Type>
        <Type
          as="p"
          variant="paragraph-lg"
          className="border-b border-core-gray-300 pb-3 font-light"
        >
          {payout.offeringType} Offering
        </Type>
      </div>
      <div className="grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-1">
        {!!campaign?.capitalRaised && (
          <DetailsRow
            stat={formatMoney(campaign.capitalRaised, {
              zeroFractionDigits: true,
            })}
            title="Raised"
          />
        )}
        {!!campaign?.investorsTotal && (
          <DetailsRow
            stat={campaign.investorsTotal.toLocaleString()}
            title="Investors"
          />
        )}
        <DetailsRow
          stat={`${payout.percentROI}%`}
          title="Return on Investment"
          info={payout.infoROI.fields.text}
        />
        {payout.daysUntilProcessed && (
          <DetailsRow
            stat={payout.daysUntilProcessed.toLocaleString()}
            title="Days"
            subtitle="Time it took for the return to be processed after offering closed."
          />
        )}
        <DetailsRow stat={payout.investmentType} />
      </div>

      {payout.payoutDetailsDisclaimer.fields.text && (
        <TextBlock
          document={payout.payoutDetailsDisclaimer.fields.text}
          optionOverrides={disclaimerOverride}
        />
      )}
    </div>
  )
}

export default DetailsCard
